import request from "./request";
import config from '@/config'
const baseUrl = config.service.surveyUrl
const baseUrl2 = config.service.apiUrl
const baseUrl3 = 'http://localhost:8092'


export default {
  getSummaryInfo(summaryId,qrCodeId) {
	let url = `${baseUrl}/summary/report?summaryId=`+summaryId;
	if(qrCodeId && qrCodeId != 'null' && qrCodeId != "undefined"){
		url += '&qrCodeId='+qrCodeId
	}
    return request({
      url: url,
      method: 'get'
    })
  },
  getScsSummaryReport(summaryId,fromPage, qrCodeId) {
	  let url = `${baseUrl}/summary/report/scs?noAuth=true&summaryId=${summaryId}&fromPage=${fromPage}`;
	  
	  if (qrCodeId) {
		  url = url + "&qrCodeId="+qrCodeId;
	  }
    return request({
      url: url,
      method: 'get',
      // params: {
      //   summaryId: summaryId
      // }
    });
  },
  // 发送消息
  getUserG3ReportStatus(summaryId) {
    let userId = localStorage.getItem("userId");
    return request({
      url: `${baseUrl2}/user/corp/wechat/sendMessage?summaryId=${summaryId}&userId=${userId}`,
      method: 'get',

    });
  },
  updateSurveyUserInfo(user) {
    return request({
      url: `${baseUrl}/user/info/update`,
      method: 'post',
      data: user
    });
  },
  getReportList(userId) {
    return request({
      url: `${baseUrl}/summary/getAllSummaryInfo?userId=${userId}&unionId=-1`,
      method: 'get'
    });
  },
  getLastG3Info(userId) {
    return request({
      url: `${baseUrl}/summary/getLastSummaryInfo?userId=${userId}`,
      method: 'get'
    });
  },
  updateSurveyor(data) {
    return request({url: baseUrl + '/user/info/save', method:'POST', data});
  },
  getSurveyor(data) {
    return request({url: baseUrl + '/user/info/detail', method:'POST', data});
  },
  generateTransferQrcode(queryStr) {
	let url = baseUrl + '/summary/transfer/qr';
	return request({url: url, method:'GET', params: {queryStr}});
  },
  checkSummaryTransfer(summaryId) {
	return request({url: baseUrl + '/summary/transfer/check?summaryId='+summaryId, method:'GET'});
  },
  checkSummaryTransferAuth(summaryId) {
  	return request({url: baseUrl + '/summary/transfer/check/auth?summaryId='+summaryId, method:'GET'});
  },
  transferSurveyor(data) {
	return request({url: baseUrl + '/user/info/transfer', method:'POST', data});
  },
  getScsAndG3SummaryList(userId,channel,hasOrderId) {
    return request({
      url: `${baseUrl}/summary/getScsAndG3SummaryList?userId=${userId}&channel=${channel}&hasOrderId=${hasOrderId}`,
      method: 'get'
    });
  },
  checkG3Record() {
	return request({
      url: `${baseUrl}/summary/findG3ByUserId`,
      method: 'get'
    });
  },
  getJySurveyInfo(userId){
	return request({
		url: `${baseUrl}/summary/getJySurveyInfo?userId=${userId}`,
		method: 'get',
	});
  },
  getPosterHtb(summaryId) {
	return request({
	    url:`${baseUrl}/api/poster/htb?summaryId=${summaryId}`,
	    method: 'post',
	    data:{}
	})
  },
  getQybReportList(unionId) {
    return request({
      url: `${baseUrl}/summary/getQybReportList?unionId=${unionId}`,
      method: 'post'
    });
  },
  getTurtleSoupConfig() {
    return request({
      url: `${baseUrl}/chatbot-turtlesoup/getTurtleSoupConfig`,
      method: 'get'
    });
  },
  getTopicByDate(time) {
    return request({
      url: `${baseUrl}/chatbot-turtlesoup/getTopicByDate?useDate=`+time,
      method: 'get'
    });
  },
  getTopicByDateV2(time,puzzleType) {
    return request({
      url: `${baseUrl}/chatbot-turtlesoup/getTopicByDate?useDate=${time}&puzzleType=${puzzleType}`,
      method: 'get'
    });
  },
  createRound() {
    return request({
      url: `${baseUrl}/chatbot-turtlesoup/createRound`,
      method: 'post'
    });
  },
  askBotQuestion(data) {
    return request({
      url: `${baseUrl}/chatbot-turtlesoup/askBotQuestion`,
      method: 'post',
	  data
    });
  },
  checkGetRightAnswer(data) {
    return request({
      url: `${baseUrl}/chatbot-turtlesoup/checkGetRightAnswer`,
      method: 'post',
	  data
    });
  },
  createTopic() {
    return request({
      url: `${baseUrl}/chatbot-turtlesoup/createTopic`,
      method: 'post'
    });
  },
  saveTopic() {
    return request({
      url: `${baseUrl}/chatbot-turtlesoup/saveTopic`,
      method: 'post'
    });
  },

  getTurtlesoupLog(data) {
    return request({
      url: `${baseUrl}/chatbot-turtlesoup/log/conversation`,
      method: 'post',
      data
    });
  },

  chatBotIdiomguess(data) {
    return request({
      url: `${baseUrl}/chatbot-idiomguess/conversation`,
      method: 'post',
      data
    });
  },

  findTodayLastRound(data) {
    return request({
      url: `${baseUrl}/chatbot-turtlesoup/round/findTodayLastRound`,
      method: 'post',
      data
    });
  },

  saveFeedback(data) {
    return request({
      url: `${baseUrl}/chatbot-turtlesoup/saveFeedback`,
      method: 'post',
      data
    });
  },

  checkSummaryAndUser(data) {
    return request({
      url: `${baseUrl}/summary/checkSummaryAndUser`,
      method: 'post',
      data
    });
  },
  getUserReport(union_id,name) {
    let url = `${baseUrl}/intelligent_survey/record/recent?union_id=${union_id}`
    if(name){
      url += `&name=${name}`
    }
    return request({
      url,
      method: 'get'
    })
  },
  createRisk(data) {
    return request({url: baseUrl + '/risk/create ', method:'POST', data});
  },
  getJuweiInfoByChannel (channel){
  	return request({
  	    url:  baseUrl + '/survey/getChannelJuweiInfo?channel='+channel,
  	    method: 'GET',
  	});
  },
  getCorpInfo(summaryId) {
	  let url = `${baseUrl}/summary/getCorpInfo?summaryId=${summaryId}`;
	  return request({
	      url,
	      method: 'GET',
	  });
  },
  printG3Report(data) {
	  return request({
	    url: `${baseUrl2}/survey/survey/printG3Report`,
	    method: 'post',
		data
	  });
  },
  getHospitalSurveyInfo(channel){
	  return request({
	    url: `${baseUrl}/user/info/getHospitalSurveyInfo?channel=`+channel,
	    method: 'get'
	  });
  },
  getEncryptThirdUserInfoBySurveyUserId(surveyUserId){
	  return request({
	    url: `${baseUrl}/user/info/getEncryptThirdUserInfoBySurveyUserId?surveyUserId=`+surveyUserId,
	    method: 'get'
	  });
  }
}
